import { t as StyledSvgIcon } from "./SvgIcon.styles-A_BRPYMJ.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/Edit.svg?react
const SvgEdit = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58578C2.21071 4.96086 2 5.46956 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M18.5 2.5C18.8978 2.10217 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10217 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10217 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/EditIcon.tsx
function EditIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgEdit,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { EditIcon as t };
//# sourceMappingURL=EditIcon-DawQFG8E.js.map